<div class="alc-text alc-catalog">
  <div layout="row" class="catalog-line">
    <a class="margin-left-5" href="{{ catalog.linkToBusinessManager }}">{{ catalog.name }}</a>
    <button mat-button (click)="confirmThenDisconnectCatalog()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
<mat-divider></mat-divider>
